import { Inject, Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, RoutingInfo } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { DocumentUploadService } from "../documentupload-service/document-upload.service";
import { DocInfo } from "../documentupload-service/documentupload.model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export class FilePreviewState extends BaseFpxComponentState {
    showSuggestion: boolean = false;
    files: any = [];
}

@Injectable()
export class FilePreviewHelper extends BaseFpxFormHelper<FilePreviewState>{
    
    constructor(
        private _commonService: CommonService,
        public _processShellService: ProcessShellService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        protected dom: DomSanitizer,
        private dialogRef: MatDialogRef<FilePreviewHelper>,
    ) {
        super(new FilePreviewState());
    }

    public doPreInit(): void {
        this.state.files = this.data.files;
        this.setImageData();
    }

    public doDestroy(): void {
        this.dialogRef.close(this.state.files)
    }

    setImageData(){
        this.state.files.forEach((file, i) => {
            if (typeof (file) === 'object') {
                this._commonService.fileToBase64(file).then(
                    (value) => {
                        if(file.type == "application/pdf") this.state.files[i].imageSrc = './assets/images/pdf-icon.svg';
                        else this.state.files[i].imageSrc = value;
                    }
                )
            } else {
                this.state.files[i] = file;
            }
        });
    }
    previewFile(i) {
        let file = this.state.files[i]
        const blob = new Blob([file], { type: file.type });
        const url = URL.createObjectURL(blob);
        window.open(url);
    }
    onDelete(i) {
        this.state.files.splice(i,1);
    }
    public preSubmitInterceptor(payload: any) {
        
        return payload;
    }

    public postSubmitInterceptor(response: BaseFpxPostSubmitInterceptor): RoutingInfo {
        let routingInfo:RoutingInfo=new RoutingInfo();
        // WRITE CODE HERE TO HANDLE 
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
       
        return routingInfo;
    }
}